import { useReferralUpdateMutation } from "@/src/lib/data-fetchers/referrals-fetchers";
import { Referral } from "@/src/models/documents/referral";
import { Location } from "@/src/models/location";
import { Practitioner } from "@/src/models/practitioner";

type LocationFieldName = "primaryCareLocation" | "referringLocation" | "receivingLocation";
type PractitionerFieldName = "primaryCareProvider" | "referringProvider" | "receivingProvider";

// Hook for handling switching the location objects in a referral
export function useReferralLocationSwitchHandler() {
  const updateReferralMutation = useReferralUpdateMutation();

  const createLocationSwitchHandler = (referral: Referral, locationFieldName: LocationFieldName) => {
    return async (updatedLocation: Location) => {
      const updatedReferral = {
        ...referral,
        [locationFieldName]: updatedLocation,
      };

      await updateReferralMutation.mutateAsync(updatedReferral);
    };
  };

  return {
    createLocationSwitchHandler,
    isPending: updateReferralMutation.isPending,
  };
}

// Hook for handling switching the practitioner objects in a referral
export function useReferralPractitionerSwitchHandler() {
  const updateReferralMutation = useReferralUpdateMutation();

  const createPractitionerSwitchHandler = (referral: Referral, practitionerFieldName: PractitionerFieldName) => {
    return async (updatedPractitioner: Practitioner) => {
      const updatedReferral = {
        ...referral,
        [practitionerFieldName]: updatedPractitioner,
      };

      await updateReferralMutation.mutateAsync(updatedReferral);
    };
  };

  return {
    createPractitionerSwitchHandler,
    isPending: updateReferralMutation.isPending,
  };
}
